import React from 'react';
import { useFormContext } from 'react-hook-form';
import { isArray } from '@agilepoint/utils-common';
import { toBoolean } from 'common';
import { MenuOption, IMenuOptionsFormFields } from '../types';

const primaryMenuKeys = ['MyApps', 'MyTasks', 'Home', 'Outbox', 'TeamTasks', 'PlannedTasks', 'Watchlist', 'ExternalApps', 'ProcessesIStarted',
    'ProcessesIWorked', 'Delegations', 'Settings', 'Help', 'About'];

export const useMenuOptions = () => {
    const { watch } = useFormContext<IMenuOptionsFormFields>();
    const { menuOptions, locales } = watch();
    const options = Array.from(Object.entries(menuOptions[locales] ?? menuOptions.default), ([fieldName, { fieldValue, isEnabled }]) => ({ Name: fieldName, Value: fieldValue, isEnabled }));
    return primaryMenuKeys.map((key) => {
        const foundMenuOption = options.find((item) => item.Name === key);
        if (foundMenuOption) {
            return { Name: key, Value: foundMenuOption.Value, isEnabled: foundMenuOption.isEnabled };
        }
        return { Name: key, Value: key, isEnabled: true };
    });
};

export const useMenuOptionsDefaultValues = (menuOptions: MenuOption[] | IMenuOptionsFormFields) => React.useMemo(() => {
    if (isArray(menuOptions)) {
        const allOptions = primaryMenuKeys.map((key) => {
            const foundMenuOption = menuOptions.find((item) => item.Name === key);
            if (foundMenuOption) {
                return { Name: key, Value: foundMenuOption.Value, isEnabled: foundMenuOption.isEnabled };
            }
            return { Name: key, Value: key, isEnabled: true };
        });

        return {
            locales: 'default',
            menuOptions: {
                default: allOptions.reduce((acc, curr) => {
                    acc[curr.Name] = {
                        fieldValue: curr.Value,
                        isEnabled: curr.isEnabled
                    };
                    return acc;
                }, {})
            }
        };
    }
    const res = menuOptions;
    Object.values(res.menuOptions).forEach((item) => {
        Object.values(item).forEach((_item) => {
            _item.isEnabled = toBoolean(_item.isEnabled);
        });
    });
    return res;
}, [menuOptions]);
